const backendUrl = "";

export { backendUrl };
